import { useEffect, useLayoutEffect, useState } from "react";
import { t } from "i18next";
import Select, { StylesConfig } from 'react-select';
import { parseLocalizedNumber, formatNumberCustomoriginal, validateCultureNumber, formatHoursOff, formatDateWithDateAndMonthName, getEmployeeNameWithCode, getFilteredList, getPageSizeArray, setItemStatus, sortData, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../../common/timeLiveFunction';
import CustomPagination from "../../../../common/Pagination";
import clsx from "clsx";
import { Dropdown } from 'react-bootstrap';
import Loader from '../../../../common/Loader';
import { ShowToast } from "../../../../common/Toastr";
import { ShowSwalWithConfirmation } from "../../../../common/SweetAlert";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  getAccountEmployeeTimeOffByAccountEmployeeId, checkedAllState, unCheckedAllState, checkedState, unCheckedState,
  setEditState, setLastEarnedDateState, resetSelectedRecordObjectInState, UpdateTimeOffStatus, ResetTimeOffPolicy
} from "../EmployeeTimeOffSlice";
import DatePicker from "react-datepicker";
import PageSizeSelect from "../../../../common/PageSizeSelect";
import * as Sentry from "@sentry/react";
import moment from "moment";

const initialSortValues = {
  sortOrder: 'asc',
  sortColumn: 'AccountTimeOffType'
}

const EmployeeTimeOffList = (props: any) => {
  const { employeeNameWithCode, IsTimeOffEdit, AccountEmployeeId } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { employeeTimeOffList, employeeTimeOffListForEdit, isLoading, isReload } = useAppSelector((state) => state.employeeTimeOff);
  const { decimalPlaces, cultureInfoName, IsList, customMenuList, accountPreferenceList, isShowTimeOffInDays, isTimeOffStatusEditMode, showEmployeeNameBy, calendarStartDay } = useAppSelector((state) => state.globalState);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditTimeOff, setIsEditTimeOff] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
  const showConsumedHours = accountPreferenceList[0]?.IsShowConsumedHours ?? false;
  // const [hoveredColumn, setHoveredColumn] = useState(null);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  }

  const handleSearch = (event: any) => {
    const { value } = event.target;
    setSearchTerm(value);
    setCurrentPage(1);
  }

  const handlePageSizeChange = (selectedOption: any) => {
    const { value, label } = selectedOption;
    setPageSize(Number(value));
    setCurrentPage(1);
  }

  const filteredData = getFilteredList(employeeTimeOffList, searchTerm);
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const currentItems = sortData(filteredData, clientSideSorting.sortOrder, clientSideSorting.sortColumn).slice(indexOfFirstItem, indexOfLastItem);
  const totalItems = employeeTimeOffList.length;
  const recordsFiltered = filteredData.length;

  useEffect(() => {
    // dispatch(getAccountEmployeeTimeOffByAccountEmployeeId({ "AccountEmployeeId": AccountEmployeeId, "cultureInfoName": cultureInfoName.toString() }));
    dispatch(getAccountEmployeeTimeOffByAccountEmployeeId(AccountEmployeeId));
  }, [dispatch]);

  useEffect(() => {
    if (isReload) {
      // dispatch(getAccountEmployeeTimeOffByAccountEmployeeId({ "AccountEmployeeId": AccountEmployeeId, "cultureInfoName": cultureInfoName.toString() }));
      dispatch(getAccountEmployeeTimeOffByAccountEmployeeId(AccountEmployeeId));
    }
  }, [isReload]);

  const onHandleIsEditTimeOff = (e: any) => {
    const { checked } = e.target;
    if (!checked && isUpdated && employeeTimeOffListForEdit.length > 0) {
      ShowSwalWithConfirmation("", "You have some unsaved change(s) left. Are you sure you don't want to update records(s)?", `Yes, discard it!`)
        .then((result) => {
          if (result) {
            setIsEditTimeOff(checked);
            setIsUpdated(false);
            dispatch(resetSelectedRecordObjectInState());
          }
        })
        .catch((error) => {
          Sentry.captureException(error);
        });
    }
    else {
      setIsEditTimeOff(checked);
      setIsUpdated(true);
    }
  }

  const handleChange = (e: any, obj: any) => {
    let value = e.target.value;
    let id = e.target.id;
    dispatch(setEditState({ AccountEmployeeTimeOffId: obj.AccountEmployeeTimeOffId, value: value, id: id }))
  }

  const onlastEarnedDateChange = (obj: any, date: any) => {
    dispatch(setLastEarnedDateState({ AccountEmployeeTimeOffId: obj.AccountEmployeeTimeOffId, value: new Date(date).toISOString() }))
  }

  const onUpdateEditRecords = () => {
    const parsedList = employeeTimeOffList.map(item => ({
      ...item,
      EarnedDay: parseLocalizedNumber(item.EarnedDay),
      AvailableDay: parseLocalizedNumber(item.AvailableDay),
      Earned: parseLocalizedNumber(item.Earned),
      Available: parseLocalizedNumber(item.Available)
    }));
    dispatch(UpdateTimeOffStatus({
      employeeTimeOffList: parsedList, IsShowTimeOffInDays: isShowTimeOffInDays
      , IsTimeOffStatusEditMode: isTimeOffStatusEditMode, EmployeeNameWithCode: employeeNameWithCode
    }))
      .unwrap()
      .then((originalPromiseResult) => {
        originalPromiseResult.StatusCode === "200" ?
          ShowToast('success', 'Record Updated Successfully!', "success", "toast-top-right") :
          ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
        dispatch(resetSelectedRecordObjectInState());
      })
      .catch((rejectedValueOrSerializedError) => {
        Sentry.captureException(rejectedValueOrSerializedError);
      })
  }

  const onResetTimeOffPolicy = () => {
    dispatch(ResetTimeOffPolicy({
      AccountEmployeeId: AccountEmployeeId ? AccountEmployeeId : 0,
      employeeNameWithCode: employeeNameWithCode
    }))
      .unwrap()
      .then((originalPromiseResult) => {
        originalPromiseResult.StatusCode === "200" ?
          ShowToast('success', 'Reset TimeOff Policy Successfully!', "success", "toast-top-right") :
          ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
      })
      .catch((rejectedValueOrSerializedError) => {
        Sentry.captureException(rejectedValueOrSerializedError);
      })
  }

  const navigateToEmployeeTimeOffAudit = (AccountTimeOffTypeId: any, AccountEmployeeId: any) => {
    const obj = {
      AccountEmployeeId: AccountEmployeeId,
      AccountTimeOffTypeId: AccountTimeOffTypeId,
      TableName: 'AccountEmployeeTimeOffAudit',
      Title: getValueFromResource('Employee Time Off Audit', dispatch, t)
    }
    navigate(`/employeetimeoffaudit/${AccountTimeOffTypeId}`, { state: { obj } });
  };

  const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
    setClientSideSorting({
      ...clientSideSorting,
      sortOrder: sortOrder,
      sortColumn: sortColumn
    });
    setPageSize(10);
    setCurrentPage(1);
  }

  // const handleMouseEnter = (columnIndex: any) => {
  //   setHoveredColumn(columnIndex);
  // }

  // const handleMouseLeave = () => {
  //   setHoveredColumn(null);
  // }

  return (
    <>
      {isLoading && <Loader />}
      <div className="card card-custom admin-card">
        <div className="card-header card-drop sticky-top bg-white">
          <h3 className="card-title fw-bold headerTitle">
            {/* {t('Time Off List')} */}
            {getValueFromResource('Time Off List', dispatch, t)}
          </h3>
          <div className="card-toolbar align-items-center">
            {IsTimeOffEdit && isTimeOffStatusEditMode &&
              <>
                <span className="me-2 text-muted">
                  {getValueFromResource('Edit Time Off Policy', dispatch, t)}
                </span>
                <div className="form-check form-switch form-check-custom"
                  data-tooltip-id="tooltip-Description"
                  data-tooltip-content=
                  // {t("Edit Time Off Policy")}
                  {getValueFromResource('Edit Time Off Policy', dispatch, t)}
                  data-tooltip-place="top"
                >
                  <input
                    type="checkbox"
                    className="form-check-input custom-padding-right h-15px w-30px"
                    checked={isEditTimeOff}
                    onChange={(e) => { onHandleIsEditTimeOff(e) }}
                  />
                </div>
                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
              </>
            }
            <div className="position-relative">
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearch}
                placeholder=
                // {t('Search')}
                {getValueFromResource('Search', dispatch, t)}
                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                data-kt-user-table-filter="search"
              />
              <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            </div>
            <div className='h-35px w-1px mx-1'></div>
            <div className="d-flex align-items-center">
              {/* <Select
                styles={colourStyles}
                options={getPageSizeArray()}
                value={getPageSizeArray().find((option: any) => option.value == pageSize)}
                onChange={handlePageSizeChange}
                className='fs-7 fw-normal'
              /> */}
              <PageSizeSelect onChange={handlePageSizeChange} />

            </div>
            {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
            <div>
              {(employeeTimeOffList.length > 0) ? (
                <CustomPagination
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                  pageSize={pageSize}
                  totalItems={totalItems}
                  start={(currentPage - 1) * pageSize}
                  t={t}
                >
                </CustomPagination>
              ) : null}
            </div> */}
            {(employeeTimeOffList.length > 0) && (
              <>
                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                <div>
                  <CustomPagination
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    pageSize={pageSize}
                    totalItems={totalItems}
                    start={(currentPage - 1) * pageSize}
                    t={t}
                  />
                </div>
              </>
            )}
            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
            {isEditTimeOff ? (
              <>
                <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm "
                  onClick={() => { onUpdateEditRecords() }}
                  style={{ marginRight: '2px' }}
                >
                  {/* {t('Update')} */}
                  {getValueFromResource('Update', dispatch, t)}
                </button>
              </>
            ) : null}
            {employeeTimeOffList.length > 0 ? (
              <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm "
                onClick={() => { onResetTimeOffPolicy() }}
                style={{ marginRight: '2px' }}
              >
                {/* {t('Reset Policy')} */}
                {getValueFromResource('Reset Policy', dispatch, t)}
              </button>
            ) : null}
          </div>
        </div>
        {/* <div className='card-body py-3'> */}
        <div className="card-Report-body py-3">

          <div className='table-responsive'>
            <table className={`table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1`} style={{ width: '100%' }}>
              <thead>
                <tr className='thHeading align-middle'>
                  <th style={{ width: '20%' }}
                  // onMouseEnter={() => handleMouseEnter(0)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Time Off Type")} */}
                    {getValueFromResource('Time Off Type', dispatch, t)}
                    {clientSideSorting.sortColumn === 'AccountTimeOffType' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountTimeOffType") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountTimeOffType") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 0 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountTimeOffType") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountTimeOffType") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  {isShowTimeOffInDays ?
                    (<th style={{ width: '12%' }}
                    // onMouseEnter={() => handleMouseEnter(1)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Earned Days")} */}
                      {getValueFromResource('Earned Days', dispatch, t)}
                      {clientSideSorting.sortColumn === 'EarnedDay' ?
                        clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EarnedDay") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EarnedDay") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 1 && 
                        <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EarnedDay") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EarnedDay") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>) :
                    (<th style={{ width: '12%' }}
                    // onMouseEnter={() => handleMouseEnter(2)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Earned Hours")} */}
                      {getValueFromResource('Earned Hours', dispatch, t)}
                      {clientSideSorting.sortColumn === 'Earned' ?
                        clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Earned") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Earned") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 2 && 
                        <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Earned") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Earned") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>)
                  }
                  {showConsumedHours && (
                   isShowTimeOffInDays ? (
                    <th style={{ width: '12%' }}
                    // onMouseEnter={() => handleMouseEnter(3)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Consumed Days")} */}
                      {getValueFromResource('Consumed Days', dispatch, t)}
                      {clientSideSorting.sortColumn === 'ConsumeDay' ?
                        clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ConsumeDay") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ConsumeDay") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 3 && 
                        <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ConsumeDay") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ConsumeDay") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>
                    ) :(
                    //   <>
                    // {showConsumedHours && 
                    (<th style={{ width: '12%' }}
                    // onMouseEnter={() => handleMouseEnter(4)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Consumed Hours")} */}
                      {getValueFromResource('Consumed Hours', dispatch, t)}
                      {clientSideSorting.sortColumn === 'Consume' ?
                        clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Consume") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Consume") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 4 && 
                        <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Consume") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Consume") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>)
                    // }
                    //   </>
                  )
                )}
                  {isShowTimeOffInDays ?
                    (<th style={{ width: '15%' }}
                    // onMouseEnter={() => handleMouseEnter(5)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Carray Forward Days")} */}
                      {getValueFromResource('Carray Forward Days', dispatch, t)}
                      {clientSideSorting.sortColumn === 'CarryForwardDay' ?
                        clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "CarryForwardDay") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "CarryForwardDay") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 5 && 
                        <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "CarryForwardDay") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "CarryForwardDay") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>) :
                    (<th style={{ width: '15%' }}
                    // onMouseEnter={() => handleMouseEnter(6)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Carray Forward Hours")} */}
                      {getValueFromResource('Carray Forward Hours', dispatch, t)}
                      {clientSideSorting.sortColumn === 'CarryForward' ?
                        clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "CarryForward") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "CarryForward") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 6 && 
                        <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "CarryForward") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "CarryForward") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>)
                  }
                  {isShowTimeOffInDays ?
                    (<th style={{ width: '12%' }}
                    // onMouseEnter={() => handleMouseEnter(7)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Available Days")} */}
                      {getValueFromResource('Available Days', dispatch, t)}
                      {clientSideSorting.sortColumn === 'AvailableDay' ?
                        clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AvailableDay") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AvailableDay") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 7 && 
                        <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AvailableDay") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AvailableDay") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>) :
                    (<th style={{ width: '12%' }}
                    // onMouseEnter={() => handleMouseEnter(8)}
                    // onMouseLeave={handleMouseLeave}
                    >
                      {/* {t("Available Hours")} */}
                      {getValueFromResource('Available Hours', dispatch, t)}
                      {clientSideSorting.sortColumn === 'Available' ?
                        clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Available") }}>
                          <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Available") }}>
                          <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                        </span>
                        :
                        // hoveredColumn === 8 && 
                        <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Available") }}>
                          <i className="bi bi-sort-up fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                          <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Available") }}>
                            <i className="bi bi-sort-down fs-6 headerSortIcon">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </span>
                        </>}
                    </th>)
                  }
                  <th style={{ width: '12%' }}
                  // onMouseEnter={() => handleMouseEnter(9)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Last Earned Date")} */}
                    {getValueFromResource('Last Earned Date', dispatch, t)}
                    {clientSideSorting.sortColumn === 'LastEarnedDate' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "LastEarnedDate") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "LastEarnedDate") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 9 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "LastEarnedDate") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "LastEarnedDate") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '12%' }}
                  // onMouseEnter={() => handleMouseEnter(10)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Last Reset Date")} */}
                    {getValueFromResource('Last Reset Date', dispatch, t)}
                    {clientSideSorting.sortColumn === 'LastResetDate' ?
                      clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "LastResetDate") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "LastResetDate") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 10 && 
                      <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "LastResetDate") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "LastResetDate") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 && currentItems.map((item: any) => {
                
                  return (
                    <tr key={item.AccountEmployeeTimeOffId}>
                      <td>
                        <a className='text-dark fw-bold d-block cursor'
                          onClick={() => navigateToEmployeeTimeOffAudit(item.AccountTimeOffTypeId, AccountEmployeeId)}>
                          {item.AccountTimeOffType}
                        </a>
                      </td>
                      {isShowTimeOffInDays ?
                        (
                          <>
                            <td>
                              {isEditTimeOff ? (
                                <input type="text"
                                  className="form-control form-control-sm fs-7 fw-normal"
                                  id='EarnedDay'
                                  style={{ width: "100px" }}
                                  value={item.EarnedDay}
                                  //onChange={(e: any) => handleChange(e, item)}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                      handleChange(e, item);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const formatted = formatNumberCustomoriginal(
                                      cultureInfoName.toString(),
                                      item.EarnedDay,
                                      decimalPlaces
                                    );
                                    const syntheticEvent = {
                                      target: {
                                        id: 'EarnedDay',
                                        value: formatted
                                      }
                                    } as any;
                                    handleChange(syntheticEvent, item);
                                  }}
                                />
                              ) : (
                                <span className="d-block">{item.EarnedDay}</span>
                              )}
                            </td>
                            {showConsumedHours && 
                            <td>
                              <span className="d-block">{item.ConsumeDay}</span>
                            </td>}
                            <td>
                              <span className="d-block">{item.CarryForwardDay}</span>
                            </td>
                            <td>
                              {isEditTimeOff ? (
                                <input type="text"
                                  className="form-control form-control-sm fs-7 fw-normal "
                                  id='AvailableDay'
                                  style={{ width: "100px" }}
                                  value={item.AvailableDay}
                                  //onChange={(e: any) => handleChange(e, item)}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                      handleChange(e, item);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const formatted = formatNumberCustomoriginal(
                                      cultureInfoName.toString(),
                                      item.AvailableDay,
                                      decimalPlaces
                                    );
                                    const syntheticEvent = {
                                      target: {
                                        id: 'AvailableDay',
                                        value: formatted
                                      }
                                    } as any;
                                    handleChange(syntheticEvent, item);
                                  }}
                                />
                              ) : (
                                <span className="d-block">{item.AvailableDay}</span>
                              )}
                            </td>
                          </>
                        ) :
                        (
                          <>
                            <td>
                              {isEditTimeOff ? (
                                <input type="text"
                                  className="form-control form-control-sm fs-7 fw-normal"
                                  style={{ width: "100px" }}
                                  id='Earned'
                                  value={item.Earned}
                                  //onChange={(e: any) => handleChange(e, item)}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                      handleChange(e, item);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const formatted = formatNumberCustomoriginal(
                                      cultureInfoName.toString(),
                                      String(item.Earned),
                                      decimalPlaces
                                    );
                                    const syntheticEvent = {
                                      target: {
                                        id: 'Earned',
                                        value: formatted
                                      }
                                    } as any;
                                    handleChange(syntheticEvent, item);
                                  }}
                                />
                              ) : (
                                <span className="d-block">{item.Earned}</span>
                              )}
                            </td>
                            {showConsumedHours&& <td>
                              <span className="d-block">{item.Consume}</span>
                            </td>}
                            <td>
                              <span className="d-block">{item.CarryForward}</span>
                            </td>
                            <td>
                              {isEditTimeOff ? (
                                <input type="text"
                                  className="form-control form-control-sm fs-7 fw-normal"
                                  style={{ width: "100px" }}
                                  id='Available'
                                  value={item.Available}
                                  //onChange={(e: any) => handleChange(e, item)}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                      handleChange(e, item);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const formatted = formatNumberCustomoriginal(
                                      cultureInfoName.toString(),
                                      String(item.Available),
                                      decimalPlaces
                                    );
                                    const syntheticEvent = {
                                      target: {
                                        id: 'Available',
                                        value: formatted
                                      }
                                    } as any;
                                    handleChange(syntheticEvent, item);
                                  }}
                                />
                              ) : (
                                <span className="d-block">{item.Available}</span>
                              )}
                            </td>
                          </>
                        )
                      }
                      <td>
                        {isEditTimeOff ? (
                          <div style={{ width: "100px" }}>
                            <DatePicker
                              selected={item.LastEarnedDate == null ? new Date() : new Date(item.LastEarnedDate)}
                              onChange={e => onlastEarnedDateChange(item, e)}
                              calendarStartDay={calendarStartDay}
                              id="LastEarnedDate"
                              className="form-control form-control-sm fs-7 fw-normal col-md-1"

                            >
                            </DatePicker>
                          </div>
                        ) : (
                          <span className="d-block">
                            {/* {item.LastEarnedDate ? new Date(item.LastEarnedDate).toLocaleDateString() : ''} */}
                            {item.LastEarnedDate ? formatDateWithDateAndMonthName(item.LastEarnedDate, cultureInfoName.toString()) : ''}
                          </span>
                        )}
                      </td>
                      <td>
                        <span className="d-block">
                          {/* {item.LastResetDate ? new Date(item.LastResetDate).toLocaleDateString() : ''} */}
                          {/* {item.LastResetDate ? moment(item.LastResetDate).format('DD MMM yy') : ''} */}
                          {item.LastResetDate ? formatDateWithDateAndMonthName(item.LastResetDate, cultureInfoName.toString()) : ''}
                        </span>
                      </td>
                      <td className='text-center'>
                        <Dropdown
                          style={{ marginLeft: 1 }}
                          className={clsx('cursor-pointer symbol')}
                          data-kt-menu-attach='parent'
                          data-kt-menu-placement='bottom-end'
                        >
                          <Dropdown.Toggle
                            variant="transparent"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("More")}
                            {getValueFromResource('More', dispatch, t)}
                            data-tooltip-place="top"
                          >
                            <i className="bi bi-three-dots fs-7"></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                            <div className='menu-hover-bg-sec'
                              onClick={() => navigateToEmployeeTimeOffAudit(item.AccountTimeOffTypeId, AccountEmployeeId)}
                            /* onClick={() => {
                              navigateToEmployeeTimeOffAudit({
                                AccountTimeOffTypeId: item.AccountTimeOffTypeId,
                                AccountEmployeeId: AccountEmployeeId,
                                TableName: 'AccountEmployeeTimeOffAudit',
                                Title: getValueFromResource('Employee Time Off Audit v3', dispatch, t)
                              });
                            }} */
                            >
                              <Dropdown.Item
                                className="menu-item me-lg-0"
                              >
                                <span className="menu-icon custom-menu mb-2">
                                  <i className="bi bi-file-earmark-text fs-4 iconColor">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                  </i>
                                </span>
                                <span className="menu-title custom-menu-fontsize">
                                  {/* {`${t('Audit')}`} */}
                                  {getValueFromResource('Audit', dispatch, t)}
                                </span>
                              </Dropdown.Item>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            {employeeTimeOffList.length === 0 &&
              <div className=''>
                <p className='noDataFound'>
                  {/* {t('No Record Found')} */}
                  {getValueFromResource('No Record Found', dispatch, t)}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeTimeOffList

const colourStyles: StylesConfig = {
  control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}